export default {
  errors: null,
  shops: [],
  loading: false,
  count: 0,
  totalCount: 0,
  loaded: false,
};
